import deepmerge, {Options} from "deepmerge";

const overwriteMerge = <T>(target: T[], source: T[], options?: Options) => source || target;

export default function merge<T>(...objects: (Partial<T> | undefined | null)[]): T {
    return deepmerge.all<T>(objects.filter(Boolean) as Partial<T>[], {
        arrayMerge: overwriteMerge
    });
}